import React, { useEffect, useState, useCallback } from "react";
import API, { CONFIG, UPDATE_CONFIG } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { Button, InputNumber, message } from "antd";
import ModalCommon from "../../components/Modal";
// Removed date libraries (not used on this screen)


const TEXT = {
    phase1: "Giai đoạn 1",
    phase2: "Giai đoạn 2",
    minDeposit: "Nạp tối thiểu",
    bettingRevenue: "Doanh thu cược",
    BanCa: 'BẮN CÁ',
    Slot: 'SLOTS',
    Casino: 'CASINO',
    GameViet: 'GAME VIỆT',
    TheThao: 'THỂ THAO',
    save: "Lưu",
}

const SetupCondition = () => {
    const [isShowModalConfirm, setIsShowModalConfirm] = useState(false);
    const [isShowModalSuccess, setIsShowModalSuccess] = useState(false);

    const [maxTurn, setMaxTurn] = useState();
    const [phase1MinDeposit, setPhase1MinDeposit] = useState();
    const [phase2MinDeposit, setPhase2MinDeposit] = useState();
    const [dtcBanCa, setDTCBanCa] = useState();
    const [dtcSlot, setDTCSlot] = useState();
    const [dtcCasino, setDTCCasino] = useState();
    const [dtcGameViet, setDTCGameViet] = useState();
    const [dtcTheThao, setDTCTheThao] = useState();
    // No date range on this simplified screen
    const [messageApi, contextHolder] = message.useMessage();

    const showError = useCallback((errorMessage) => {
        messageApi.open({
            type: 'error',
            content: errorMessage,
        });
    }, [messageApi]);

    const getDataConfig = useCallback(async () => {
        try {
            const res = await API.get(`${CONFIG}`);
            const data = res.data?.data || res.data;
            const playPhases = data?.playPhases || {};
            const phase1 = playPhases?.phase1 || {};
            const phase2 = playPhases?.phase2 || {};
            const dtcRequirements = phase2?.dtcRequirements || {};
            
            const phase1Deposit = phase1?.minDeposit || data?.minDeposit || 0;
            const phase2Deposit = phase2?.minDeposit || data?.minDeposit || 0;
            
            setPhase1MinDeposit(phase1Deposit);
            setPhase2MinDeposit(phase2Deposit);
            setDTCBanCa(dtcRequirements[3] || dtcRequirements['3'] || 0);
            setDTCSlot(dtcRequirements[1] || dtcRequirements['1'] || 0);
            setDTCCasino(dtcRequirements[4] || dtcRequirements['4'] || 0);
            setDTCGameViet(dtcRequirements[2] || dtcRequirements['2'] || 0);
            setDTCTheThao(dtcRequirements[5] || dtcRequirements['5'] || 0);
            setMaxTurn(data?.maxTurns || data?.maxDailyTurns);
        } catch (err) {
            console.log(err);
            showError("Không thể tải dữ liệu cấu hình");
        }
    }, [showError]);

    useEffect(() => {
        getDataConfig();
    }, [getDataConfig]);

    const handleChangeInput = (e, key) => {
        switch (key) {
            case 1: setPhase1MinDeposit(e); return;
            case 2: setPhase2MinDeposit(e); return;
            case 3: setDTCBanCa(e); return;
            case 4: setDTCSlot(e); return;
            case 5: setDTCCasino(e); return;
            case 6: setDTCGameViet(e); return;
            case 7: setDTCTheThao(e); return;
            default: return;
        }
        
    };

    const handleUpdateConfig = async () => {
        try {
            setIsShowModalConfirm(false);

            if (
                !validNumber(phase1MinDeposit) || !validNumber(phase2MinDeposit) || 
                !validNumber(dtcBanCa) || !validNumber(dtcSlot) || !validNumber(dtcCasino) || 
                !validNumber(dtcGameViet) || !validNumber(dtcTheThao)
            ) {
                showError("Vui lòng nhập số hợp lệ");
                return;
            }

            const config = {
                playPhases: {
                    phase1: {
                        minDeposit: parseInt(phase1MinDeposit),
                    },
                    phase2: {
                        minDeposit: parseInt(phase2MinDeposit),
                        dtcRequirements: {
                            1: parseInt(dtcSlot),
                            2: parseInt(dtcGameViet),
                            3: parseInt(dtcBanCa),
                            4: parseInt(dtcCasino),
                            5: parseInt(dtcTheThao),
                        }
                    }
                }
            };

            // Nếu có maxTurns, thêm vào config
            if (maxTurn) {
                config.maxTurns = parseInt(maxTurn);
            }

            const body = {
                config: config
            };
            
            await API.patch(`${UPDATE_CONFIG}`, body);
            setIsShowModalSuccess(true);
            
            // Reload data sau khi update thành công
            setTimeout(() => {
                getDataConfig();
            }, 1000);
        } catch (err) {
            console.log(err);
            showError(err?.response?.data?.message || "Cập nhật cấu hình thất bại");
            setIsShowModalSuccess(false);
        }
    };

    const validNumber = (value) => {
        if (value === undefined || value === null || value === "") {
            return false;
        }
        const number = parseInt(value);
        return !isNaN(number) && number > 0;
    }


    const handleShowModal = () => {
        setIsShowModalConfirm(true);
    };

    const renderInputNumer = (key, defaultValue, changeInput, max, label) => {
        return (
            <div className={`flex w-full items-center ${key !== "maxTurn" ? "mt-4" : ""}`}>
                <div className="flex w-[20%] justify-end mr-10">{label}:</div>
                <div className="w-[60%]">
                    <InputNumber
                        key={key}
                        style={{ width: "100%" }}
                        value={defaultValue}
                        onChange={changeInput}
                        max={max}
                        min={1}
                        controls={true}
                    />
                </div>
            </div>
        )
    }

    const renderSection = (title, children) => {
        return (
            <div className="w-full mb-6">
                <div className="text-lg font-semibold mb-4">{title}</div>
                {children}
            </div>
        )
    }

    return (
        <div className="col-12">
            {contextHolder}
            {(phase1MinDeposit !== undefined && phase2MinDeposit !== undefined) && 
                <div className="col-12">
                    <div className="flex w-full">
                        <div className="flex flex-col w-full items-center justify-center">
                            <div className="col-10 mt-2 flex flex-col items-center justify-center">
                                {renderSection(TEXT.phase1,
                                    renderInputNumer(
                                        "phase1MinDeposit",
                                        phase1MinDeposit, 
                                        (e) => handleChangeInput(e, 1), 
                                        20000, TEXT.minDeposit
                                    )
                                )}

                                {renderSection(TEXT.phase2,
                                    renderInputNumer(
                                        "phase2MinDeposit",
                                        phase2MinDeposit, 
                                        (e) => handleChangeInput(e, 2), 
                                        20000, TEXT.minDeposit
                                    )
                                )}

                                {renderSection(TEXT.bettingRevenue,
                                    <>
                                        {renderInputNumer(
                                            "dtcBanCa",
                                            dtcBanCa, 
                                            (e) => handleChangeInput(e, 3), 
                                            100000, TEXT.BanCa
                                        )}

                                        {renderInputNumer(
                                            "dtcSlot",
                                            dtcSlot, 
                                            (e) => handleChangeInput(e, 4), 
                                            100000, TEXT.Slot
                                        )}

                                        {renderInputNumer(
                                            "dtcCasino",
                                            dtcCasino, 
                                            (e) => handleChangeInput(e, 5), 
                                            100000, TEXT.Casino
                                        )}

                                        {renderInputNumer(
                                            "dtcGameViet",
                                            dtcGameViet, 
                                            (e) => handleChangeInput(e, 6), 
                                            100000, TEXT.GameViet
                                        )}

                                        {renderInputNumer(
                                            "dtcTheThao",
                                            dtcTheThao, 
                                            (e) => handleChangeInput(e, 7), 
                                            100000, TEXT.TheThao
                                        )}
                                    </>
                                )}
                            </div>
                            <div className="col-10 mt-5 flex items-center justify-end">
                                <Button type="primary" onClick={handleShowModal}>
                                    {TEXT.save}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isShowModalConfirm && (
                <ModalCommon
                    isShow={isShowModalConfirm}
                    message={TEXT_DEF.text0062}
                    txtBtnAcc={TEXT_DEF.text0008}
                    textBtnClose={TEXT_DEF.text0023}
                    actionNext={handleUpdateConfig}
                    close={() => setIsShowModalConfirm(false)}
                />
            )}
            {isShowModalSuccess && (
                <ModalCommon
                    isShow={isShowModalSuccess}
                    message={TEXT_DEF.text0063}
                    txtBtnAcc={TEXT_DEF.text0007}
                    actionNext={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                    close={() => {
                        setIsShowModalSuccess(false);
                        getDataConfig();
                    }}
                />
            )}
        </div>
    );
};

export default SetupCondition;
